import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { useParams } from 'react-router-dom';
import MechaMainStore from '@src/pages/mecha/sections/main/store';
import MechaWeaponStore from '@src/pages/mecha/sections/weapon/store';
import MechaMoreStore from '@src/pages/mecha/sections/change-more/store';
import message from '@src/components/common-message';
import { useEffect } from 'react';
import doResize from '@src/utils/do-resize';
import CommonDemoModalStore from './sections/modal/store';
import CommonDemoModal from './sections/modal';
import useModal from '@src/utils/hooks/use-modal';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import { jumpPage } from '@src/utils/common-util';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import Toast from '@src/components/toast';

class MechaStore extends BaseStore {
  // 主屏
  main = new MechaMainStore({ mechaStore: this });

  // 机甲武器模块
  weapon = new MechaWeaponStore({ mechaStore: this });
  // 查看更多
  more = new MechaMoreStore({ mechaStore: this });

  modalStore = new CommonDemoModalStore({ mechaStore: this });

  @observable currentMacheId;
  handleOpen = () => {
    if (this?.mechaInfo) {
      this.modalStore.isOpen = true;
      this.modal.open();
      this.mechaInfo.mecha_name = this.currentMechaMsg?.mecha_name;
    } else {
      Toast.info(getLocales('global.comming_soon'));
    }
  };

  backTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // 机甲详情信息
  @observable currentMechaMsg;

  // 机甲详情信息
  @observable mechaList;
  @observable mecha_weapon;

  // 弹窗信息
  @observable mechaInfo;

  // 当前机甲id
  @observable mechaId;
  // 底部swiper切换index
  //是否播放当前视频
  // @observable isPlayingCurrentVideo = false;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }
  onBackToTop = () => {
    const el = document.getElementById('mecha-page');
    el.scrollIntoView({ behavior: 'smooth' });
  };

  /**
   * 返回首页
   */
  onClickBackHome = () => {
    if (!IS_DEV_ENV) {
      const url = 'mecha-list.html';
      jumpPage(url, '#/');
    } else {
      this.redirect('/mecha-list');
    }
  };

  /**
   * 切换到其他的详情页
   * @param mechaId
   */
  onClickChangeMecha = mechaId => {
    this.onBackToTop();

    if (!IS_DEV_ENV) {
      const url = 'mecha.html';
      jumpPage(url, `#/?mecha_id=${mechaId}`);
    } else {
      this.redirect(`/mecha?mecha_id=${mechaId}`);
    }

    this.main.isActive = false;
    this.weapon.isActive = false;
    this.more.isActive = false;

    this.initMechaMsg(mechaId);
    this.weapon.isPlayingCurrentVideo = false;
  };

  initMechaMsg(mechaId) {
    this.more.currentMechaId = mechaId;

    // const isMechaIdPresent = this.mechaList.some(mecha => mecha.mecha_id == mechaId);
    // if (!isMechaIdPresent) {
    //   message.info('检查到机兵编号有误!!! 正在返回首页!!!');
    //   // this.redirect('/');
    //   return false;
    // }

    // if (mechaId === 'pinaka') {
    //   message.info('该机兵档案暂未公开');
    //   this.redirect('/');
    //   return false;
    // }

    this.currentMechaMsg = this.mechaList?.find(item => item.mecha_id == mechaId);
  }

  init(pageData, mechaId) {
    this.mechaList = pageData?.mecha_list;
    this.mecha_weapon = pageData?.mecha_weapon;
    const mechaInfoList = pageData?.mecha_info;
    this.mechaInfo = mechaInfoList?.find(info => info.mecha_id === mechaId);
    this.mechaList = this.mechaList?.map(mecha => {
      const weapon = this.mecha_weapon?.filter(weapon => weapon.weapon_id == mecha.mecha_id);

      if (weapon?.length > 0) {
        mecha.weapon = weapon; // 直接赋值为对象
      }
      return mecha;
    });

    if (this.mechaList?.length > 0) {
      this.initMechaMsg(mechaId);
    }
  }

  use() {
    super.use();

    this.modal = useModal(CommonDemoModal, { store: this.modalStore });

    const pageData = useFunLinkPageData();
    const mechaId = this.$routeMatch.query.mecha_id;
    this.currentMacheId = mechaId;
    useEffect(
      () => {
        if (pageData) {
          this.init(pageData, mechaId);
        }
      },
      [pageData, mechaId]
    );

    useMount(async () => {});

    useEffect(() => {
      doResize();
    }, []);
  }
}

export default MechaStore;
